import { combineReducers } from "redux";
import labelReducer from "./labelReducer";
import errorReducer from "./errorReducer";
import profileReducer from "./profileReducer";
import viewDataReducer from "./viewDataReducer";

export default combineReducers({
  labels: labelReducer,
  errors: errorReducer,
  profile: profileReducer,
  view: viewDataReducer,
});
